import React from 'react';

const ArchivedAssets = () => (
  <div className="mx-auto w-full max-w-lg py-6">
    <h1 className="text-2xl font-bold">Archived Assets</h1>
  </div>
);

export default ArchivedAssets;
